import * as React from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
    const { t } = useTranslation("common");

    return (
        <div className="mt-25 dell-footer">
            <footer className="container d-flex flex-wrap justify-content-between align-items-center py-1">
                <p className="col-md-6 mb-0">{t("dell_cr")}</p>

                <ul className="nav col-md-6 justify-content-end">
                    <li className="nav-item"><a target="_blank" rel="noopener noreferrer" href="http://www.dell.com/about" className="nav-link px-2">{t("abt_dell")}</a></li>
                    <li className="nav-item"><a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/learn/us/en/uscorp1/terms-conditions/art-software-license-agreements" className="nav-link px-2">{t("t_and_s")}</a></li>
                    <li className="nav-item"><a target="_blank" rel="noopener noreferrer" href="http://www.dell.com/learn/us/en/uscorp1/policies-privacy" className="nav-link px-2">{t("privacy_policy")}</a></li>
                    <li className="nav-item"><a href="https://www.dell.com/support/home/en-us/product-support/product/wyse-wms/overview" target="_blank" rel="noopener noreferrer" className="nav-link px-2">{t("support")}</a></li>
                </ul>
            </footer>
        </div>
    );
}